exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/profesionales/editar-profesional/editar-profesional.component.scss
// module id = ../../../../../src/app/carga/profesionales/editar-profesional/editar-profesional.component.scss
// module chunks = 1